module.exports = __webpack_public_path__ + "media/images/metronic/portlet-collapse-icon-e5f66129d1e28a35cd22286a191f40f4.png";